import BaseRepository from '@/api/repositories/BaseRepository';

export default class PDFBlueprintRepository extends BaseRepository {
	getAllBlueprints() {
		return this.get('pdfblueprints', {});
	}

	getBlueprintValuesByID(blueprintID) {
		return this.get(`pdfblueprints/${blueprintID}`, {});
	}

	resetBlueprintValues(blueprintID) {
		return this.put(`pdfblueprints/${blueprintID}/resetToDefaults`, {});
	}

	changeValuesForBlueprintID(blueprintID, valueID, value) {
		return this.put(`pdfblueprints/${blueprintID}/values`, {}, { id: valueID, value: value });
	}

	updateBulkBlueprintValues(blueprintID, values) {
		return this.put(`pdfblueprints/${blueprintID}/values`, {}, { values: values });
	}

	getBlueprintValueByID(blueprintValueID) {
		return this.get(`pdfblueprints/values/${blueprintValueID}`, {});
	}

	getBlueprintSamples() {
		return this.get('pdfblueprintsamples', {});
	}

	getBlueprintSampleValues(sampleID) {
		return this.get(`pdfblueprintsamples/${sampleID}/values`, {});
	}

	updateBlueprintSampleValues(sampleID, values) {
		return this.put(`pdfblueprintsamples/${sampleID}/values`, {}, { values: values, id: sampleID });
	}
}
